import { lazy } from "react";
import ChallengeCategory from "./pages/dashboard/challenges/category/ChallengeCategory.jsx";
import RegisterCategory from "./pages/dashboard/challenges/category/registerCategory/RegisterCategory.jsx";
import ReviewChallenge from "./pages/dashboard/challenges/review/ReviewChallenge.jsx";

const Login = lazy(() => import("./pages/login/Login"));
const DashboardLayout = lazy(() => import("./pages/dashboard/DashboardLayout"));
const Ngo = lazy(() => import("./pages/dashboard/ngo/Ngo.jsx"));
const RegisterNgo = lazy(() =>
  import("./pages/dashboard/ngo/register-ngo/RegisterNgo.jsx")
);
const Admins = lazy(() => import("./pages/dashboard/admins/Admins.jsx"));
const Challenges = lazy(() =>
  import("./pages/dashboard/challenges/Challenges.jsx")
);
const RegisterChallenge = lazy(() =>
  import("./pages/dashboard/challenges/register-callenge/RegisterChallenge.jsx")
);
const Event = lazy(() => import("./pages/dashboard/events/event/Event.jsx"));
const EventReview = lazy(() =>
  import("./pages/dashboard/events/review/EventReview.jsx")
);
const RegisteEvent = lazy(() =>
  import("./pages/dashboard/events/register-event/RegisterEvent.jsx")
);

const Members = lazy(() => import("./pages/members/Members.jsx"));
const LeagueLeaderboard = lazy(() =>
  import("./pages/dashboard/leaderboard/LeagueLeaderboard.jsx")
);
const TotalLeaderboard = lazy(() =>
  import("./pages/dashboard/leaderboard/TotalLeaderboard.jsx")
);
const ElectedLeaderboard = lazy(() =>
  import("./pages/dashboard/leaderboard/ElectedLeaderboard.jsx")
);
const NewMember = lazy(() =>
  import("./pages/dashboard/leaderboard/NewMember.jsx")
);
const MemberInfo = lazy(() =>
  import("./pages/dashboard/leaderboard/MemberInfo.jsx")
);
const Tickets = lazy(() => import("./pages/dashboard/tickets/Tickets.jsx"));
const Ticket = lazy(() =>
  import("./pages/dashboard/tickets/response/Ticket.jsx")
);
const Dashboard = lazy(() => import("./pages/dashboard/index/Dashboard.jsx"));
const Sites = lazy(() => import("./pages/dashboard/sites/Sites.jsx"));
const RegisterSite = lazy(() =>
  import("./pages/dashboard/sites/register-site/Site.jsx")
);
const Policy = lazy(() => import("./pages/dashboard/policy/Policy.jsx"));
const Plan = lazy(() => import("./pages/dashboard/plan/Plan.jsx"));
const RegisteredMembers = lazy(() =>
  import("./pages/dashboard/challenges/registered/RegisteredMembers.jsx")
);

let routes = [
  { path: `/`, element: <Login /> },
  // { path: `/dashboard`, element: <DashboardLayout /> },
  //   TODO: Make the Routes dynamic
  {
    path: `/dashboard`,
    element: <DashboardLayout />,
    children: [
      { path: "", element: <Dashboard /> },
      { path: "admins", element: <Admins /> },
      { path: "challenges", element: <Challenges /> },
      { path: "challenges/:challengeId", element: <ReviewChallenge /> },
      {
        path: "challenges/registered/:challengeId",
        element: <RegisteredMembers />,
      },
      { path: "challenges/new", element: <RegisterChallenge /> },
      { path: "challenges/new?:id", element: <RegisterChallenge /> },
      { path: "challenges/category", element: <ChallengeCategory /> },
      { path: "challenges/category/new", element: <RegisterCategory /> },
      { path: "challenges/category/new/:catId", element: <RegisterCategory /> },
      { path: "events/register-event", element: <RegisteEvent /> },
      { path: "events/:eventId", element: <Event /> },
      { path: "events/review/:eventId", element: <EventReview /> },
      { path: "members", element: <Members /> },
      { path: "members/league", element: <LeagueLeaderboard /> },
      { path: "members/total", element: <TotalLeaderboard /> },
      { path: "members/elected", element: <ElectedLeaderboard /> },
      { path: "member/new", element: <NewMember /> },
      { path: "member/new/:memberId", element: <NewMember /> },
      { path: "member/:memberId", element: <MemberInfo /> },
      { path: "tickets", element: <Tickets /> },
      { path: "tickets/:id", element: <Ticket /> },
      { path: "sites", element: <Sites /> },
      { path: "sites/new", element: <RegisterSite /> },
      { path: "sites/new?:siteId", element: <RegisterSite /> },
      { path: "plan", element: <Plan /> },
      // { path: "policy", element: <Policy /> },
    ],
  },
];

export default routes;
